import { useItemsAccess } from '@/hooks/useItemsPermissions';
import { Navigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { useEffect } from 'react';
import { useAdminCheck } from '@/hooks/useAdminCheck';

interface ItemsProtectedRouteProps {
  children: React.ReactNode;
}

const ItemsProtectedRoute = ({ children }: ItemsProtectedRouteProps) => {
  const { isAdmin, isLoading: isAdminLoading } = useAdminCheck();
  const { data: hasAccess, isLoading } = useItemsAccess();
  const { toast } = useToast();

  useEffect(() => {
    if (!isLoading && !hasAccess && !isAdmin) {
      toast({
        title: "Truy cập bị từ chối",
        description: "Bạn không có quyền truy cập trang quản lý Items.",
        variant: "destructive",
      });
    }
  }, [hasAccess, isLoading, isAdmin, toast]);

  // Admin override - admins always have access
  if (isAdmin) {
    return <>{children}</>;
  }

  if (isLoading || isAdminLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Đang kiểm tra quyền truy cập...</p>
        </div>
      </div>
    );
  }

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ItemsProtectedRoute;